/**
 * Businesses API — CRUD for businesses under the organization.
 */

import { api } from "./client";
import type { Business } from "../types/models";

export interface CreateBusinessRequest {
  name: string;
  business_type?: string;
  gstin?: string;
  pan?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  phone?: string;
  email?: string;
}

export interface UpdateBusinessRequest {
  name?: string;
  /** One currency per business (#25). The server accepts only a code this
   *  product supports, which is the list the settings screen offers. */
  currency?: string;
  business_type?: string;
  gstin?: string;
  pan?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  phone?: string;
  email?: string;
  is_active?: boolean;
}

export const businessesApi = {
  /** List all businesses in the organization */
  listBusinesses(): Promise<Business[]> {
    return api.get<Business[]>("/org/businesses");
  },

  /** Get a single business */
  getBusiness(businessId: string): Promise<Business> {
    return api.get<Business>(`/org/businesses/${businessId}`);
  },

  /** Create a new business */
  createBusiness(data: CreateBusinessRequest): Promise<Business> {
    return api.post<Business>("/org/businesses", data);
  },

  /** Update a business */
  updateBusiness(businessId: string, data: UpdateBusinessRequest): Promise<Business> {
    return api.put<Business>(`/org/businesses/${businessId}`, data);
  },

  /** Delete a business */
  deleteBusiness(businessId: string): Promise<void> {
    return api.del(`/org/businesses/${businessId}`);
  },

  /** Get current business profile */
  getBusinessProfile(): Promise<Business> {
    return api.get<Business>("/business");
  },

  /** Update current business profile */
  updateBusinessProfile(data: Partial<Business>): Promise<Business> {
    return api.put<Business>("/business", data);
  },
};
